// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export default {
  'Login.title': `Tell me about you`,
  'Login.teacherTitle': `Teachers can`,
  'Login.teacherDescription1': `Create a classroom`,
  'Login.teacherDescription2': `Share audio, video, and screen`,
  'Login.teacherDescription3': `Send chat messages`,
  'Login.teacherDescription4': `Toggle focus:`,
  'Login.teacherToggleDescription1': `Focus mutes all students`,
  'Login.teacherToggleDescription2': `Focus turns off student chat`,
  'Login.teacherButton': `I'm a teacher`,

  'Login.studentTitle': `Students can`,
  'Login.studentDescription1': `Join a classroom`,
  'Login.studentDescription2': `Share video`,
  'Login.studentDescription3': `Raise hand`,
  'Login.studentDescription4': `When focus is off:`,
  'Login.studentToggleDescription1': `Unmute and share audio`,
  'Login.studentToggleDescription2': `Send chat messages`,
  'Login.studentButton': `I'm a student`,

  'CreateOrJoin.teacherTitle': `Create or join a classroom`,
  'CreateOrJoin.studentTitle': `Join a classroom`,
  'CreateOrJoin.titlePlaceholder': `Classroom`,
  'CreateOrJoin.namePlaceholder': `Your name`,
  'CreateOrJoin.continueButton': `Continue`,
  'CreateOrJoin.notTeacherLink': `Not a teacher? Click here.`,
  'CreateOrJoin.notStudentLink': `Not a student? Click here.`,
  'CreateOrJoin.classRoomDoesNotExist': `Classroom does not exist`,
  'CreateOrJoin.serverError': `Server error`,

  'Classroom.classroom': `Classroom`,

  'RemoteVideoGroup.noVideo': `No one is sharing video`,

  'DeviceSwitcher.noAudioInputPlaceholder': `No microphone`,
  'DeviceSwitcher.noAudioOutputPlaceholder': `No speaker`,
  'DeviceSwitcher.noVideoInputPlaceholder': `No video device`,

  'Controls.turnOffFocusTooltip': `Turn off focus`,
  'Controls.turnOnFocusTooltip': `Turn on focus`,
  'Controls.unmuteTooltip': `Unmute`,
  'Controls.muteTooltip': `Mute`,
  'Controls.turnOnVideoTooltip': `Turn on video`,
  'Controls.turnOffVideoTooltip': `Turn off video`,
  'Controls.shareScreenTooltip': `Share screen`,
  'Controls.endClassroomTooltip': `End classroom`,
  'Controls.leaveClassroomTooltip': `Leave classroom`,
  'Controls.micMutedInScreenViewMode': `Mic muted`,
  'Controls.focusOnMessage': `Focus on`,
  'Controls.focusOffMessage': `Focus off`,

  'ScreenPicker.title': `Share your screen`,
  'ScreenPicker.applicationWindowTab': `Application window`,
  'ScreenPicker.yourEntireScreenTab': `Your entire screen`,
  'ScreenPicker.noScreen': `No screen`,
  'ScreenPicker.cancel': `Cancel`,
  'ScreenPicker.share': `Share`,

  'ScreenShareHeader.stopSharing': `Stop sharing`,
  'ScreenShareHeader.online': `{number} online`,

  'ChatInput.inputPlaceholder': `Type a chat message`,
  'ChatInput.raiseHandAriaLabel': `Raise hand`,

  'Roster.raiseHandAriaLabel': `Raised hand by {name}`,

  'RemoteVideo.raiseHandAriaLabel': `Raised hand`
};
